var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe1682(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1682",
    "data-name": "Groupe 1682",
    transform: "translate(-13228 -1394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1288",
    "data-name": "Rectangle 1288",
    d: "M0,0H97a0,0,0,0,1,0,0V57.5A48.5,48.5,0,0,1,48.5,106h0A48.5,48.5,0,0,1,0,57.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(13228 1394)",
    fill: "#f3f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1678",
    "data-name": "Groupe 1678",
    transform: "translate(149 263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "money-recive",
    transform: "translate(13109 1166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.312,15.156A15.156,15.156,0,1,1,15.156,0",
    transform: "translate(3.031 3.031)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0V6.062H6.062",
    transform: "translate(25.765 4.547)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M7.578,0,0,7.578",
    transform: "translate(25.765 3.031)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H36.374V36.374H0Z",
    transform: "translate(0)",
    fill: "none",
    opacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M7.216-9.478q-2.944,0-3.673,3.719H8.25v1.19H3.414L3.4-4.042v.591l.018.415H7.687v1.19H3.562A4.832,4.832,0,0,0,4.84.724a3.444,3.444,0,0,0,2.505.909A7.141,7.141,0,0,0,10.2,1.024V2.408a7.11,7.11,0,0,1-2.925.6,4.96,4.96,0,0,1-3.52-1.241A6.281,6.281,0,0,1,1.993-1.846H.461v-1.19h1.4l-.018-.388V-3.83l.018-.738H.461v-1.19H1.975A6.5,6.5,0,0,1,3.682-9.515a4.779,4.779,0,0,1,3.534-1.347,6.541,6.541,0,0,1,3.377.9L9.939-8.684A6.062,6.062,0,0,0,7.216-9.478Z",
    transform: "translate(13121.422 1188.229)",
    fill: "#1b7afa",
    stroke: "#1b7afa",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1682);
export default __webpack_public_path__ + "static/media/Groupe-1682.5474cffcfc32c86f7682e917f0f3f555.svg";
export { ForwardRef as ReactComponent };